export default "__VITE_ASSET__DIjmOQDG__"